/**
 * Created by Administrador on 27/07/2019.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('cargoReceivedRegionCtrl', cargoReceivedRegionCtrl)
        .controller('cargoReceivedOfficeCtrl', cargoReceivedOfficeCtrl)
        .controller('cargoReceivedDestinationsCtrl', cargoReceivedDestinationsCtrl)
        .controller('cargoComingStockCtrl', cargoComingStockCtrl)
        .controller('cargoNotDeliveredCtrl', cargoNotDeliveredCtrl)
        .controller('cargoLowAnnulmentCtrl', cargoLowAnnulmentCtrl)
        .controller('cargoDeliveredCtrl', cargoDeliveredCtrl);

    cargoReceivedRegionCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService',
        'linkService','cargoReportService','branchOffices','dateService'];
    cargoReceivedOfficeCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService',
        'linkService','cargoReportService','branchOffices','dateService'];
    cargoReceivedDestinationsCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService',
        'linkService','cargoReportService','cities','dateService'];
    cargoComingStockCtrl.$inject = ['cities', 'tabs', 'branchOfficeService', 'linkService',
        'userService','userSession', 'excelService','cargoReportService'];
    cargoNotDeliveredCtrl.$inject = ['cities', 'tabs', 'type', 'branchOfficeService', 'linkService', 'userService',
        'userSession', 'excelService','cargoReportService', 'dateService', 'datePickerService'];
    cargoLowAnnulmentCtrl.$inject = ['$stateParams', 'tabs', 'userSession', 'type', 'datePickerService',
        'linkService','cargoReportService','cities','dateService', 'branchOfficeService', 'excelService', 'printService'];
    cargoDeliveredCtrl.$inject = ['$stateParams', 'tabs', 'userSession', 'datePickerService',
        'linkService','cargoReportService','cities','dateService', 'branchOfficeService', 'excelService', 'printService'];

    function cargoReceivedOfficeCtrl($stateParams, tabs, datePickerService, linkService, cargoReportService,
                                     branchOffices,dateService){
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.branchOffices = branchOffices.data._embedded ? branchOffices.data._embedded.branchOffices: [];
        vm.report = undefined;
        vm.filterReport =
            {
                detailed : true,
                fromDate: new Date(),
                toDate: new Date()
            }

        vm.dateParam = $stateParams.date;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterReport.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterReport.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterReport.toDate = new Date();
            vm.filterReport.fromDate = new Date();
            vm.report = undefined;
        }

        vm.exportPdf = function(detailed){
            cargoReportService.getReceptionByOfficePdf(vm.linkService.getLinkId(vm.branchOffice._links.self.href),
                dateService.dateTimeString(vm.filterReport.fromDate, 1),
                vm.filterReport.detailed ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                detailed)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "Carga_recibida_oficina_"+(detailed?"Detallado_":"Resumen_")+new Date().getTime()+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.branchOffice != undefined){
                cargoReportService.getReceptionByOffice(vm.linkService.getLinkId(vm.branchOffice._links.self.href),
                    dateService.dateTimeString(vm.filterReport.fromDate, 1),
                    vm.filterReport.detailed ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                    vm.filterReport.detailed)
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }
    }

    function cargoReceivedRegionCtrl($stateParams, tabs, datePickerService, linkService, cargoReportService,
                                     branchOffices,dateService){
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.branchOffices = branchOffices.data._embedded ? branchOffices.data._embedded.branchOffices: [];
        vm.report = undefined;
        vm.filterReport =
            {
                detailed : true,
                fromDate: new Date(),
                toDate: new Date()
            }

        vm.dateParam = $stateParams.date;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterReport.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterReport.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterReport.toDate = new Date();
            vm.filterReport.fromDate = new Date();
            vm.report = undefined;
        }

        vm.exportPdf = function(detailed){
            var cityId = vm.linkService.getLinkIds(vm.branchOffice._embeddeds.city._links.self.href);
            cargoReportService.getReceptionByRegionPdf(cityId[0], dateService.dateTimeString(vm.filterReport.fromDate, 1),
                vm.filterReport.detailed ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                detailed)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "Carga_recibida_region_"+(detailed?"Detallado_":"Resumen_")+new Date().getTime()+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.branchOffice != undefined){
                var cityId = vm.linkService.getLinkIds(vm.branchOffice._embeddeds.city._links.self.href);
                cargoReportService.getReceptionByRegion(cityId[0], dateService.dateTimeString(vm.filterReport.fromDate, 1),
                    vm.filterReport.detailed ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                    vm.filterReport.detailed)
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }
    }

    function cargoReceivedDestinationsCtrl($stateParams, tabs, datePickerService, linkService, cargoReportService,
                                           cities,dateService){
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.cities = cities;
        vm.report = undefined;
        vm.filterReport =
            {
                detailed : true,
                fromDate: new Date(),
                toDate: new Date()
            }

        vm.dateParam = $stateParams.date;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterReport.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterReport.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterReport.toDate = new Date();
            vm.filterReport.fromDate = new Date();
            vm.report = undefined;
        }

        vm.exportPdf = function(detailed){
            var cityRegionOrigin = vm.linkService.getLinkId(vm.cityOrigin._links.self.href);
            var cityRegionDestiny = vm.linkService.getLinkId(vm.cityDestiny._links.self.href);
            cargoReportService.getReceptionByCityPdf(cityRegionOrigin.substring(0,cityRegionOrigin.indexOf('_')),
                cityRegionDestiny.substring(0,cityRegionDestiny.indexOf('_')),
                dateService.dateTimeString(vm.filterReport.fromDate, 1),
                (vm.filterReport.detailed) ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                detailed)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "Carga_recibida_destinos_"+(detailed?"Detallado":"Resumen")+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.cityOrigin != undefined && vm.cityDestiny != undefined){
                var cityRegionOrigin = vm.linkService.getLinkId(vm.cityOrigin._links.self.href);
                var cityRegionDestiny = vm.linkService.getLinkId(vm.cityDestiny._links.self.href);
                cargoReportService.getReceptionByCity(cityRegionOrigin.substring(0,cityRegionOrigin.indexOf('_')),
                    cityRegionDestiny.substring(0,cityRegionDestiny.indexOf('_')),
                    dateService.dateTimeString(vm.filterReport.fromDate, 1),
                    (vm.filterReport.detailed) ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                    vm.filterReport.detailed)
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }
    }

    function cargoComingStockCtrl(cities, tabs, branchOfficeService, linkService,userService,userSession,
                       excelService, cargoReportService){
        var vm = this;
        vm.tabs = tabs;
        vm.userSession = userSession.data;
        vm.cities = cities;
        vm.branchOffices = [];
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);

        if(vm.userSession.positionType != "GENERAL_ADMIN"){
            vm.cities = getCities(vm.cities,vm.userSession);
        }

        vm.filterPassages = {
            destinyCity: null,
            destinyBranchOffice: null
        };

        vm.isReport = false;

        vm.onChangeCleanReport = function () {
            vm.isReport = false;
        }

        vm.onChangeBranchOffice = function() {
            vm.isReport = false;
            var city = vm.filterPassages.destinyCity;
            if(city !== null && city !== undefined){
                vm.branchOffices = [];
                var cityId = linkService.getLinkId(city._links.self.href).split('_');
                branchOfficeService.getBranchOfficesByCityCargo(cityId[0])
                    .then(function (response) {
                        var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                        vm.branchOffices = res;
                        if(vm.userSession.positionType == "COUNTER"){
                            vm.branchOffices = getBranchOffices(vm.branchOffices,vm.userSession._embedded.branchOffices);
                        }
                    });
            }
        }

        vm.generateTransactionPassenger = function (isValid, formGenerateArching) {
            if(isValid){
                var destinyBranchOfficeId  = linkService.getLinkId(vm.filterPassages.destinyBranchOffice._links.self.href);

                cargoReportService.getCargoComingStockReport(destinyBranchOfficeId).then(function (response) {
                    if(response !== undefined) {
                        vm.report = response.data;
                        if(vm.report.stockList.length>0){
                            vm.isReport = true;
                        }else{
                            vm.isReport = false;
                        }
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.exportPdf = function(){
            var destinyBranchOfficeId  = linkService.getLinkId(vm.filterPassages.destinyBranchOffice._links.self.href);
            cargoReportService.getCargoComingStockReportPdf(destinyBranchOfficeId)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "reporte_carga_disponible.pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'reporte_carga_disponible');
        }

        vm.cancelGenerateTraffic = function(formGenerateArching) {
            vm.filterPassages.typeClient = null;
            vm.filterPassages.originCity = null;
            vm.filterPassages.originBranchOffice = null;
            vm.filterPassages.destinyCity = null;
            vm.filterPassages.detail = true;
            vm.destinyCities = cities;
            vm.isReport = false;
        };

        function getCities(vCities,vUserSession){
            var citiesAux = [];

            angular.forEach(vCities, function (city) {
                var cityId = linkService.getLinkId(city._links.self.href).split('_');
                if(cityId[0]==vUserSession._embedded.branchOffice.cityId){
                    citiesAux.push(city);
                }
            });
            return citiesAux;
        }

        function getBranchOffices(vBranchOffices,vSessionBranchOffice){
            var branchOfficesAux = [];
            angular.forEach(vBranchOffices, function (branchOffice) {
                angular.forEach(vSessionBranchOffice, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }
    }

    function cargoNotDeliveredCtrl(cities, tabs, type, branchOfficeService, linkService,userService,userSession,
                                  excelService, cargoReportService, dateService, datePickerService){
        var vm = this;
        vm.tabs = tabs;
        vm.userSession = userSession.data;
        vm.type = type;
        vm.cities = cities;
        vm.branchOffices = [];
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.reportCargoHtml = "";

        if(vm.userSession.positionType !== "GENERAL_ADMIN"){
            vm.cities = getCities(vm.cities,vm.userSession);
        }

        vm.filterCargo = {
            destinyCity: null,
            destinyBranchOffice: null,
            quantity: null,
            dayMonthYear: null,
            arrivalDate: null,
            destinyCityPhone: null
        };

        vm.selectCheckBox = {};

        vm.datePickerOpenStatus = {
            arrivalDate: false
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerArrivalDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dayMonthYears = dateService.getDayMonthYears();

        vm.isReport = false;

        vm.onChangeCleanReport = function () {
            vm.isReport = false;
        }

        vm.onChangeBranchOffice = function() {
            vm.isReport = false;
            var city = vm.filterCargo.destinyCity;
            if(city !== null && city !== undefined){
                vm.branchOffices = [];
                var cityId = linkService.getLinkId(city._links.self.href).split('_');
                branchOfficeService.getBranchOfficesByCityCargo(cityId[0])
                    .then(function (response) {
                        var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                        vm.branchOffices = res;
                        if(vm.userSession.positionType == "COUNTER"){
                            vm.branchOffices = getBranchOffices(vm.branchOffices,vm.userSession._embedded.branchOffices);
                        }
                    });
            }
        }

        vm.generateCargoNotDelivery = function (isValid, formGenerateArching) {
            if(isValid){
                var destinyCityId  = linkService.getLinkId(vm.filterCargo.destinyCity._links.self.href).split('_');

                vm.isReport = false;
                if (vm.type === 'cargoNotDelivered') {
                    var destinyBranchOfficeId = linkService.getLinkId(vm.filterCargo.destinyBranchOffice._links.self.href);
                    cargoReportService.getCargoNotDelivery(destinyCityId[0], destinyBranchOfficeId, vm.filterCargo.quantity, vm.filterCargo.dayMonthYear.value).then(function (response) {
                        vm.isReport = true;
                        if(response.data !== "") {
                            vm.reportCargoHtml = response.data;
                        } else {
                            vm.isReport = false;
                        }
                    });
                } else {
                    var arrivalDate = dateService.dateTimeString(vm.filterCargo.arrivalDate, 2);
                    var delivery = vm.selectCheckBox[1] !== undefined ? vm.selectCheckBox[1] : false;
                    var notDelivery = vm.selectCheckBox[2] !== undefined ? vm.selectCheckBox[2] : false;
                    var destinyCityPhoneId  = linkService.getLinkId(vm.filterCargo.destinyCityPhone._links.self.href).split('_');
                    cargoReportService.getCargoPhoneConsignee(arrivalDate, destinyCityId[0], destinyCityPhoneId[0], delivery, notDelivery).then(function (response) {
                        vm.isReport = true;
                        if(response.data !== "") {
                            vm.reportCargoHtml = response.data;
                        } else {
                            vm.isReport = false;
                        }
                    });
                }
            }
        }

        vm.generateReportCargoPdfHtml = function(){
            var destinyCityId  = linkService.getLinkId(vm.filterCargo.destinyCity._links.self.href).split('_');
            var destinyBranchOfficeId  = linkService.getLinkId(vm.filterCargo.destinyBranchOffice._links.self.href);
            cargoReportService.getCargoNotDeliveredPdf(destinyCityId[0], destinyBranchOfficeId, vm.filterCargo.quantity, vm.filterCargo.dayMonthYear.value)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = vm.type === 'cargoNotDelivered' ? 'reporte_carga_no_entregada.pdf' : 'reporte_carga_telefono_consignatario.pdf';
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.generateReportCargoToExcel = function (contendId) {
            var namereport = vm.type === 'cargoNotDelivered' ? 'reporte_carga_no_entregada' : 'reporte_carga_telefono_consignatario';
            excelService.exportDataToExcel(contendId, namereport);
        }

        vm.cancelGenerateReportCargo = function(formCargoNotDelivery) {
            vm.filterCargo.destinyCity = null;
            vm.filterCargo.destinyCityPhone = null;
            vm.filterCargo.destinyBranchOffice = null;
            vm.filterCargo.quantity = null;
            vm.filterCargo.dayMonthYear = null;
            vm.filterCargo.arrivalDate = null;
            vm.isReport = false;
            vm.reportCargoHtml = "";
            vm.selectCheckBox = {};
            vm.branchOffices = [];
            formCargoNotDelivery.$setPristine();
        };

        function getCities(vCities,vUserSession){
            var citiesAux = [];

            angular.forEach(vCities, function (city) {
                var cityId = linkService.getLinkId(city._links.self.href).split('_');
                if(cityId[0]==vUserSession._embedded.branchOffice.cityId){
                    citiesAux.push(city);
                }
            });
            return citiesAux;
        }

        function getBranchOffices(vBranchOffices,vSessionBranchOffice){
            var branchOfficesAux = [];
            angular.forEach(vBranchOffices, function (branchOffice) {
                angular.forEach(vSessionBranchOffice, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }
    }

    function cargoLowAnnulmentCtrl($stateParams, tabs, userSession, type, datePickerService, linkService, cargoReportService,
                                           cities,dateService, branchOfficeService, excelService, printService){
        var vm = this;

        vm.linkService = linkService;
        vm.userSession = userSession;
        vm.tabs = tabs;
        vm.type = type;
        vm.cities = cities;
        vm.branchOffices = [];
        vm.reportCargoHtml = "";
        vm.report = undefined;
        vm.filterReport =
            {
                detailed : true,
                fromDate: new Date(),
                toDate: new Date(),
                city: null,
                branchOffice: null
            }

        vm.dateParam = $stateParams.date;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterReport.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterReport.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterReport.toDate = new Date();
            vm.filterReport.fromDate = new Date();
            vm.report = undefined;
        }

        vm.onChangeBranchOffice = function() {
            var city = vm.filterReport.city;
            if(city !== null && city !== undefined){
                vm.branchOffices = [];
                var cityIds = linkService.getLinkIds(city._links.self.href);
                branchOfficeService.getBranchOfficesByCityCargo(cityIds[0])
                    .then(function (response) {
                        var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                        vm.branchOffices = res;
                        if(vm.userSession.positionType !== undefined && vm.userSession.positionType === "COUNTER"){
                            vm.branchOffices = getBranchOffices(vm.branchOffices,vm.userSession._embedded.branchOffices);
                        }
                    });
            }
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.filterReport.city !== undefined && vm.filterReport.branchOffice !== undefined){
                var branchOfficeId = vm.linkService.getLinkId(vm.filterReport.branchOffice._links.self.href);
                var fromDate = dateService.dateTimeString(vm.filterReport.fromDate, 1);
                var toDate = dateService.dateTimeString(vm.filterReport.toDate, 2);
                vm.isReport = false;
                if (vm.type === 'cargoLow') {
                    cargoReportService.getLowChargeList(fromDate, toDate, branchOfficeId)
                        .then(function (response) {
                            vm.isReport = true;
                            if(response.data !== "") {
                                vm.reportCargoHtml = response.data;
                            } else {
                                vm.isReport = false;
                            }
                        });
                } else {
                    if (vm.type === 'cargoRefund') {
                        cargoReportService.getRefundChargeList(fromDate, toDate, branchOfficeId)
                            .then(function (response) {
                                vm.isReport = true;
                                if(response.data !== "") {
                                    vm.reportCargoHtml = response.data;
                                } else {
                                    vm.isReport = false;
                                }
                            });
                    } else {
                        cargoReportService.getAnnulledStock(fromDate, toDate, branchOfficeId)
                            .then(function (response) {
                                vm.isReport = true;
                                if(response.data !== "") {
                                    vm.reportCargoHtml = response.data;
                                } else {
                                    vm.isReport = false;
                                }
                            });
                    }
                }
            }
        }

        vm.generateToPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.type === 'cargoLow' ? 'report_low' : 'report_annulment');
        }

        function getBranchOffices(vBranchOffices,vSessionBranchOffice){
            var branchOfficesAux = [];
            angular.forEach(vBranchOffices, function (branchOffice) {
                angular.forEach(vSessionBranchOffice, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }
    }

    function cargoDeliveredCtrl($stateParams, tabs, userSession, datePickerService, linkService, cargoReportService,
                                   cities,dateService, branchOfficeService, excelService, printService){
        var vm = this;

        vm.linkService = linkService;
        vm.userSession = userSession;
        vm.tabs = tabs;
        vm.cities = cities;
        vm.branchOffices = [];
        vm.reportCargoHtml = "";
        vm.report = undefined;
        vm.filterReport =
            {
                detailed : false,
                fromDate: new Date(),
                city: null,
                branchOffice: null,
                isCity: true
            }

        vm.dateParam = $stateParams.date;

        vm.datePickerOpenStatus = {
            fromDate: false,
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterReport.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                }
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.onChangeDetail = function () {
            //vm.datepickerFromDate.datepickerOptions.minDate = null;
            //vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            //vm.filterReport.fromDate = new Date();
            vm.report = undefined;
        }

        vm.onChangeBranchOffice = function() {
            var city = vm.filterReport.city;
            vm.branchOffices = [];
            if(city !== null && city !== undefined){
                var cityIds = linkService.getLinkIds(city._links.self.href);
                branchOfficeService.getBranchOfficesByCityCargo(cityIds[0])
                    .then(function (response) {
                        var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                        vm.branchOffices = res;
                        if(vm.userSession.positionType !== undefined && vm.userSession.positionType === "COUNTER"){
                            vm.branchOffices = getBranchOffices(vm.branchOffices,vm.userSession._embedded.branchOffices);
                        }
                    });
            }
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.filterReport.city !== undefined){
                var cityId = vm.linkService.getLinkIds(vm.filterReport.city._links.self.href);
                var fromDate = dateService.dateTimeString(vm.filterReport.fromDate, 1);
                vm.isReport = false;
                if (vm.filterReport.isCity) {
                    cargoReportService.getCargoDelivered(fromDate, cityId[0], 0, vm.filterReport.isCity)
                        .then(function (response) {
                            vm.isReport = true;
                            if(response.data !== "") {
                                vm.reportCargoHtml = response.data;
                            } else {
                                vm.isReport = false;
                            }
                        });
                } else {
                    var branchOfficeId = vm.linkService.getLinkId(vm.filterReport.branchOffice._links.self.href);
                    cargoReportService.getCargoDelivered(fromDate, cityId[0], branchOfficeId, vm.filterReport.isCity)
                        .then(function (response) {
                            vm.isReport = true;
                            if(response.data !== "") {
                                vm.reportCargoHtml = response.data;
                            } else {
                                vm.isReport = false;
                            }
                        });
                }
            }
        }

        vm.generateToPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'report_cargo_delivered');
        }

        function getBranchOffices(vBranchOffices,vSessionBranchOffice){
            var branchOfficesAux = [];
            angular.forEach(vBranchOffices, function (branchOffice) {
                angular.forEach(vSessionBranchOffice, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }
    }

    function cargoAnnulmentCtrl($stateParams, tabs, datePickerService, linkService, cargoReportService,
                                           cities,dateService){
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.cities = cities;
        vm.report = undefined;
        vm.filterReport =
            {
                detailed : true,
                fromDate: new Date(),
                toDate: new Date()
            }

        vm.dateParam = $stateParams.date;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterReport.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterReport.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterReport.toDate = new Date();
            vm.filterReport.fromDate = new Date();
            vm.report = undefined;
        }

        vm.exportPdf = function(detailed){
            var cityRegionOrigin = vm.linkService.getLinkId(vm.cityOrigin._links.self.href);
            var cityRegionDestiny = vm.linkService.getLinkId(vm.cityDestiny._links.self.href);
            cargoReportService.getReceptionByCityPdf(cityRegionOrigin.substring(0,cityRegionOrigin.indexOf('_')),
                cityRegionDestiny.substring(0,cityRegionDestiny.indexOf('_')),
                dateService.dateTimeString(vm.filterReport.fromDate, 1),
                (vm.filterReport.detailed) ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                detailed)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "Carga_recibida_destinos_"+(detailed?"Detallado":"Resumen")+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.cityOrigin != undefined && vm.cityDestiny != undefined){
                var cityRegionOrigin = vm.linkService.getLinkId(vm.cityOrigin._links.self.href);
                var cityRegionDestiny = vm.linkService.getLinkId(vm.cityDestiny._links.self.href);
                cargoReportService.getReceptionByCity(cityRegionOrigin.substring(0,cityRegionOrigin.indexOf('_')),
                    cityRegionDestiny.substring(0,cityRegionDestiny.indexOf('_')),
                    dateService.dateTimeString(vm.filterReport.fromDate, 1),
                    (vm.filterReport.detailed) ? dateService.dateTimeString(vm.filterReport.fromDate, 2) : dateService.dateTimeString(vm.filterReport.toDate, 2),
                    vm.filterReport.detailed)
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }
    }
})();
